"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // File was autogenerated by tools/generateLabels.js script

var _default = {
  Edit: "Edit",
  DeliveryDate: "Data wykonania usługi (data dostawy)",
  InvoiceNumber: "Numer faktury za usługę",
  Missing: "Brak"
};
exports.default = _default;